import { createSlice } from '@reduxjs/toolkit'
import { FormValuesOfferToPay } from '../../../types/offerToPay'

const offerToPaySlice = createSlice({
  name: 'offerToPay',
  initialState: {
    isEdit: false,
    dataSave: {} as FormValuesOfferToPay
  },
  reducers: {
    setEdit: (state, action) => {
      state.isEdit = action.payload
    },
    setDataSave: (state, action) => {
      state.dataSave = action.payload
    }
  }
})

export const { setEdit, setDataSave } = offerToPaySlice.actions

export default offerToPaySlice.reducer
